<div class="mat-body text-center">
    <ng-container *ngIf="data.success">
        <ng-container *ngIf="!data.client.encryptedCode">
            <h2 class="mat-headline">
                <i class="icon-check green-icon-check mb-3"></i>
                {{ 'dialog.confirm-contract.confirmation-result'|translate }}
            </h2>
            <p class="mb-5" [innerHTML]="'dialog.confirm-contract.success'|translate"></p>
        </ng-container>
        <ng-container *ngIf="!!data.client.encryptedCode">
            <h2 class="mat-headline">
                <i class="icon-check green-icon-check mb-3"></i>
                {{ 'dialog.confirm-contract.confirmation-result-old'|translate }}
            </h2>
            <p class="mb-5" [innerHTML]="'dialog.confirm-contract.success-old'|translate"></p>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!data.success">
        <ng-container *ngIf="data.isFirstContract">
            <h2 class="mat-headline">
                <i class="icon-exclamation red-icon-exclamation mb-3"></i>
                {{ 'dialog.confirm-contract.confirmation-result-error'|translate }}
            </h2>
            <p class="mb-5" [innerHTML]="'dialog.confirm-contract.error'|translate"></p>
        </ng-container>
        <ng-container *ngIf="!data.isFirstContract">
            <h2 class="mat-headline">
                <i class="icon-exclamation red-icon-exclamation mb-3"></i>
                {{ 'dialog.confirm-contract.confirmation-result-error-other-contract'|translate }}
            </h2>
            <p class="mb-5" [innerHTML]="'dialog.confirm-contract.error-other-contract'|translate"></p>
        </ng-container>
    </ng-container>

    <button type="button" class="mat-elevation-z0" mat-raised-button color="blue" (click)="onClick()">
        <span *ngIf="data.redirectToPortal">{{ 'dialog.confirm-contract.back-portal'|translate }}</span>
        <span *ngIf="!data.redirectToPortal">{{ 'dialog.confirm-contract.back-homepage'|translate }}</span>
    </button>
</div>
